import { useHttpClient } from "@/common/api/httpClient";
import type { ProductGroupResponse } from "./productGroupResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export interface ListProductGroupResponse {
  ok: true;
  groups: ProductGroupResponse[];
}

export interface ListProductGroup {
  groups: ProductGroupResponse[];
}

export function useListProductGroups() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('product/group'), {
      method: 'GET',
      headers,
    });

    const text = translations.value.productGroups.actions.fetchMany;

    const response = await httpClient.action<ListProductGroupResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as ListProductGroup;

        json.groups.sort((a, b) => a.name.localeCompare(b.name, undefined, {
          numeric: true
        }));

        return {
          ok: true,
          groups: json.groups
        };
      },
    });

    return response;
  }
}
